import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHeadset = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M18.2286 18.2286C19.6488 18.2286 20.8 17.0773 20.8 15.6571V13.0857C20.8 11.6655 19.6488 10.5143 18.2286 10.5143C17.5185 10.5143 16.9429 11.0899 16.9429 11.8V16.9428C16.9429 17.6529 17.5185 18.2286 18.2286 18.2286ZM18.2286 18.2286C18.2286 19.6487 17.0774 20.8 15.6572 20.8H12.4429M20.8 15.0143V11.8C20.8 6.82944 16.7706 2.8 11.8 2.8C6.82944 2.8 2.8 6.82944 2.8 11.8V15.0143M5.37154 18.2286C6.08162 18.2286 6.65725 17.6529 6.65725 16.9428V11.8C6.65725 11.0899 6.08162 10.5143 5.37154 10.5143C3.95133 10.5143 2.8 11.6655 2.8 13.0857V15.6571C2.8 17.0773 3.95133 18.2286 5.37154 18.2286Z",
		stroke: "white",
		strokeWidth: 2
	})
});
export default SvgHeadset;
